var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEpam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 45,
    viewBox: "0 0 35 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 14.5,
    fill: "#00ABCD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6872 15.81H18.8272V12.4595C18.8272 11.5301 18.4281 11.0541 17.4815 11.0541H17.0329C16.0968 11.0541 15.6872 11.5301 15.6872 12.4595V15.81ZM15.6872 17.8649V21.5405C15.6872 22.4699 16.158 22.9854 17.0942 22.9854H17.5044C18.4405 22.9854 18.9393 22.4699 18.9393 21.5405V19.8108H21.0701V21.5063C21.0701 23.8548 19.8586 25 17.4815 25H17.0329C14.6558 25 13.4443 23.8354 13.4443 21.7568V12.8418C13.4443 10.2135 14.6558 9 17.0329 9H17.4815C19.8586 9 21.0701 10.2135 21.0701 12.562V17.8649H15.6872Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpam);
export default __webpack_public_path__ + "static/media/epam.65186ebd4d3c814cf998b2222643c8cd.svg";
export { ForwardRef as ReactComponent };